<template>
  <div class=" bg-white">
    <form-viewer
      :dataShape="dataShape"
      :selectedObject="object"
      :collectionDBname="collectionDBname"
      class="col-11 px-0 pb-4 "
    ></form-viewer>
  </div>
</template>

<script>
import FormViewer from "../components/UI/Form/FormViewer"

export default {
  data() {
    return {}
  },
  mounted() {
    /* this.$nextTick(function() {
      this.isLoading = false
    }) */
  },
  methods: {},
  updated: function() {
    this.$nextTick(function() {
      // Code that will run only after the
      // entire view has been re-rendered
    })
  },
  components: {
    FormViewer,
  },
  props: ["collectionDBname"],
  watch: {
    collectionDBname() {
      console.log("Watch", this.collectionDBname)
    },
  },
  computed: {
    extraInfo() {
      return this.$store.getters[`${this.collectionDBname}_extraInfo`]
    },
    object() {
      return this.$store.getters[this.collectionDBname]
    },
    dataShape() {
      return this.$store.getters[`${this.collectionDBname}_dataShape`]
    },
  },
}
</script>

<style lang="scss">
.welcome {
  z-index: 9999;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.hidden {
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border: 0;
  height: 100%;
  background-color: transparent;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 100%;
  appearance: none;
}
</style>
